import { cx } from "@emotion/css";
import Subtitle from "library/Atoms/Subtitle";
import { PropTypes } from "prop-types";

const EstimationDetailsLayout = ({
  className,
  dateSection,
  priceSection,
  discountSection,
  vatSection,
  distanceSection,
  totalPriceSection,
  ...restProps
}) => (
  <div className={cx(className, "d-flex flex-column col-12 mb-3 px-0 justify-content-start")} {...restProps}>
    {dateSection && <Subtitle>{dateSection}</Subtitle>}

    <div className="d-flex flex-wrap justify-content-start col-12 px-0">
      {priceSection}

      {discountSection}

      {distanceSection}

      {vatSection}

      {totalPriceSection}
    </div>
  </div>
);

EstimationDetailsLayout.defaultProps = {
  className: null,
  dateSection: null,
  priceSection: null,
  discountSection: null,
  distanceSection: null,
  vatSection: null,
};

EstimationDetailsLayout.propTypes = {
  className: PropTypes.string,
  dateSection: PropTypes.node,
  priceSection: PropTypes.node,
  discountSection: PropTypes.node,
  distanceSection: PropTypes.node,
  vatSection: PropTypes.node,
  totalPriceSection: PropTypes.node.isRequired,
};

export default EstimationDetailsLayout;
